import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { PropertyInfoComponent } from "./views/property-info/property-info.component";
import { SharedMaterialModule } from "@app/view/shared/shared-material.module";
import { CautionWidgetComponent } from "./views/caution-widget/caution-widget.component";
import { TenantCautionListItemComponent } from "./views/tenant-caution-list-item/tenant-caution-list-item.component";
import { PropertyCautionListItemComponent } from "./views/property-caution-list-item/property-caution-list-item.component";
import { JobDescriptionWidgetComponent } from "./views/job-description-widget/job-description-widget.component";
import { JobContactWidgetComponent } from "./views/job-contact-widget/job-contact-widget.component";
import { CoreLaunchWidgetComponent } from "./views/core-launch-widget/core-launch-widget.component";
import { PropertySearchComponent } from "@app/integrations/urm/views/property-search/property-search.component";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app/view/shared";

@NgModule({
  providers: [HttpClient, UrmIntegrationModule],
  exports: [
    PropertyInfoComponent,
    CautionWidgetComponent,
    JobDescriptionWidgetComponent,
    JobContactWidgetComponent,
    CoreLaunchWidgetComponent,
    PropertySearchComponent
  ],
  imports: [
    CommonModule,
    SharedMaterialModule,
    FormsModule,
    SharedModule,
    PropertyInfoComponent,
    CautionWidgetComponent,
    TenantCautionListItemComponent,
    PropertyCautionListItemComponent,
    JobDescriptionWidgetComponent,
    JobContactWidgetComponent,
    CoreLaunchWidgetComponent,
    PropertySearchComponent
  ]
})
export class UrmIntegrationModule {}
